import React from "react";
import { NavigationContainer } from "@react-navigation/native";
import Loading from "@src/components/loading/Loading";
import AppRouting from "./AppRouting";
import Linking from "./Linking";

const AppNavigator = () => {
  return (
    <NavigationContainer linking={Linking} fallback={<Loading />}>
      <AppRouting />
    </NavigationContainer>
  );
};

export default AppNavigator;
